/**
 * Ad soyaddan bas harfler (avatar rozeti).
 *
 * BUYUK HARF CSS'TE DEGIL BURADA. `text-transform: uppercase` Turkce'de yanlis
 * donusum yapar: 'istanbul' -> 'ISTANBUL' (dogrusu 'İSTANBUL'), cunku CSS
 * tarayicinin varsayilan yerelini kullanir. `toLocaleUpperCase('tr-TR')` i -> İ
 * ve ı -> I esleşmesini dogru yapar.
 *
 * Iki yerde kullaniliyor (profil ekrani ve ust cubuk avatari); tek kopya olmasi
 * sart, yoksa birinde duzeltilen bir yerel hatasi digerinde yasamaya devam eder.
 */
export const initialsOf = (fullName: string): string =>
  fullName
    .trim()
    .split(/\s+/u)
    .slice(0, 2)
    .map((word) => (word[0] ?? '').toLocaleUpperCase('tr-TR'))
    .join('');
